export function processingHeading(content: TContent): TContent {
  return content.children[0];
}
